<template lang="pug">
  .notification
    .notification__header
      .notification__title
        template(v-if="isAdmin")
          | «{{ getPackageName(payload.packageId).title }}» на {{ payload.packageDuration }} активирован
        template(v-else)
          | Тариф «{{ getPackageName(payload.packageId).title }}» активирован
      .notification__date {{ hours }}
    .notification__body
      p.notification__content
        template(v-if="isAdmin")
          | Оплачен тариф
          strong «{{ getPackageName(payload.packageId).title }}»
          br
          | Пользователь:
          strong {{ payload.firmName }}
          br
          a(v-bind:href="'mailto:' + payload.firmEmail") {{ payload.firmEmail }}
        template(v-else)
          | Тариф активирован на {{ payload.packageDuration }}.
          br
          | Обещанный подарок — в вашем почтовом ящике.
</template>

<script>
import notification from '@/mixins/notification.mixin';

export default {
  name: 'PackageActivated',
  mixins: [notification]
};
</script>
